import {Component, computed, inject, input, signal} from '@angular/core';
import {IColumnConfig} from '../../../../../../types/IColumnConfig';
import {IconsComponent} from '../../../../../../shared/components/icons/icons.component';
import {IPriceLevel} from '../../../../../../types/IPriceLevel';
import {ResultsStore} from '../../../../../../shared/store/results.store';
import {AppStore} from '../../../../../../shared/store/app.store';
import {AccessService} from '../../../../../../shared/services/access.service';

@Component({
  selector: 'app-price-results-header-column',
  imports: [
    IconsComponent
  ],
  templateUrl: './price-results-header-column.html',
  host: {'(document:click)': 'closeDropdownOnClickOutside($event)'},
  styleUrl: './price-results-header-column.css',
})
export class PriceResultsHeaderColumn {
  column = input.required<IColumnConfig>();

  public isPriceDropdownOpen = signal(false);
  public resultsStore = inject(ResultsStore);
  public appStore = inject(AppStore);
  public access = inject(AccessService);

  readonly priceLevelVisible = computed(() => this.access.has('change_results_price_level'));
  readonly priceLevelDisabled = computed(() => this.access.cannot('change_results_price_level'));

  toggleDropdown() {
    if (this.priceLevelDisabled()) return;

    this.isPriceDropdownOpen.update(open => !open);
  }

  setPriceLevel(option: IPriceLevel) {
    this.resultsStore.setPriceLevel(option);
    this.isPriceDropdownOpen.set(false);
  }

  closeDropdownOnClickOutside(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('#results_table_price_dropdown') && !target.closest('#price_dropdown')) {
      this.isPriceDropdownOpen.set(false);
    }
  }
}
